<template>
  <div class="custom-table-content max-width-150p d-flex align-center">
    <v-avatar size="30" color="grey darken-1" class="mr-2">
      <span class="text-uppercase white--text font-size-16 fw-600">
        <slot name="first_letters"></slot>
      </span>
    </v-avatar>
    <div>
      <p
        v-if="
          !lodash.isEmpty(data.added_by) ||
          !lodash.isEmpty(data.updated_by) ||
          !lodash.isEmpty(data.added_by_display_name) ||
          !lodash.isEmpty(data.updated_by_relation)
        "
        class="m-0 custom-nowrap-ellipsis font-weight-medium py-0"
      >
        <slot name="display_name"></slot>
      </p>
      <p
        v-if="data.created_at || data.modified_at || data.added_at"
        class="m-0 py-0 custom-nowrap-ellipsis"
      >
        <slot name="date_time"></slot>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: function () {
        return {
          added_by: null,
          created_at: null,
          updated_by: null,
          modified_at: null,
        };
      },
    },
  },
};
</script>
